export default function AbstractVenturesSvg({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="179.535"
      height="34.4"
      viewBox="0 0 179.535 34.4"
      className={className}
    >
      <path
        data-name="Logo"
        d="M0 34.665c1.415 0 2.733-.1 4.1-3.513L14.687 4.9h3.074l10.15 25.471c1.317 3.269 2.44 4.294 4.148 4.294v2.2H20.347v-2.054c2.879-.146 4.1-1.122 2.928-4.148l-2-5.172H9.515l-1.9 4.928c-1.073 2.781-.586 4.392 2.44 4.392v2.049H0zm20.25-11.857L15.419 10.17 10.54 22.808z"
        transform="translate(0 -3.192)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="M93.376 32.791V4.88l-3.757-.68V2.636L96.255 0h1.171v15.078c2.489-2.976 4.44-4.148 7.27-4.148 5.319 0 8.929 4.2 8.929 10.442 0 6.88-4.44 12.833-12.3 12.833a25.387 25.387 0 0 1-7.954-1.415m9.271-.732c3.9 0 6.539-3.757 6.539-9.173 0-5.172-2.391-8.637-6.587-8.637a6.49 6.49 0 0 0-5.172 2.586v10.053a4.966 4.966 0 0 0 5.221 5.172"
        transform="translate(-58.384 -.001)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="m169.01 52.2-2.537 2.147h-.878l-.537-8.051h1.952c1.854 4.1 4.392 5.855 7.563 5.855 2.391 0 4.1-1.171 4.1-3.269 0-1.317-.683-2.635-3.074-3.562l-3.952-1.513c-3.806-1.464-5.66-3.318-5.66-6.295 0-3.855 3.22-6.295 7.124-6.295a6.37 6.37 0 0 1 5.026 2.2l2.537-2.05h.83v7.222h-1.954c-1.61-4-3.562-4.977-5.807-4.977-2.537 0-4 1.268-4 3.074 0 1.366.83 2.391 2.976 3.172l4.343 1.561c3.513 1.268 5.416 3.318 5.416 6.392 0 3.806-2.928 6.734-7.417 6.734a8.915 8.915 0 0 1-6.051-2.345"
        transform="translate(-107.53 -20.338)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="m226.837 39.566.146-13.223h-3.806v-2.684h2.537l4.245-5.319h.927v5.319h6.978v2.684h-6.978v12.3c0 2.781 1.269 4.245 3.708 4.245a5.723 5.723 0 0 0 3.757-1.561l.732.878c-1.464 2.293-3.513 3.9-6.051 3.9-3.708 0-6.246-2-6.2-6.539"
        transform="translate(-145.392 -11.948)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="M278.118 49.431V36.988l-3.318-.683v-1.464l5.807-2.635h1.561v4.2c3.074-3.416 4.684-4.343 6.343-4.343a2.426 2.426 0 0 1 2.635 2.391 3.712 3.712 0 0 1-2.049 3.074l-3.513-2a10.167 10.167 0 0 0-3.416 2.586v11.805c0 2.147.683 2.684 3.416 2.684h.732v1.952h-11.76V52.6c2.83 0 3.562-.537 3.562-3.172"
        transform="translate(-178.864 -20.886)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="M338.665 50.878c-2.1 2.733-4 3.757-6.148 3.757a4.764 4.764 0 0 1-4.977-4.977c0-2.879 1.805-4.587 5.319-6l5.758-2.245v-1.9c0-2.976-1.415-4.733-4.2-4.733-1.952 0-3.708.976-5.611 3.562l-1.61-1.073c2.733-4.44 5.758-5.9 8.734-5.9 4.1 0 6.734 2.83 6.734 7.563V49.56c0 1.122.39 1.9 1.659 1.9a2.916 2.916 0 0 0 2.1-1.073l.293 1.22c-1.708 2.293-2.879 3.025-4.343 3.025-2.2 0-3.416-1.659-3.708-3.757m-4.148.439a6.208 6.208 0 0 0 4.1-1.805V44l-3.66.83c-2.342.586-3.416 1.9-3.416 3.708a2.708 2.708 0 0 0 2.976 2.781"
        transform="translate(-213.158 -20.43)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="M384.9 44.034a12.217 12.217 0 0 1 12.048-12.394c3.709 0 6.051 1.61 6.051 3.562a2.774 2.774 0 0 1-2.635 2.489l-4.2-4.05c-3.952.488-7.173 3.855-7.173 9.027 0 4.343 2.245 8.344 7.417 8.344 2.732 0 4.782-1.073 6.49-4l1.22 1.025c-2.147 4.879-5.611 6.782-9.417 6.782-5.855 0-9.807-4.977-9.807-10.784"
        transform="translate(-250.746 -20.612)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="m448.194 39.566.146-13.223h-3.806v-2.684h2.537l4.245-5.319h.927v5.319h6.978v2.684h-6.978v12.3c0 2.781 1.269 4.245 3.708 4.245a5.723 5.723 0 0 0 3.757-1.561l.732.878c-1.464 2.293-3.513 3.9-6.051 3.9-3.708 0-6.246-2-6.2-6.539"
        transform="translate(-289.598 -11.948)"
        fill="currentColor"
      ></path>
      <path
        data-name="Logo"
        d="M499.713 85.984a2.684 2.684 0 1 1 2.733 2.684 2.657 2.657 0 0 1-2.733-2.684"
        transform="translate(-325.546 -54.267)"
        fill="currentColor"
      ></path>
    </svg>
  );
}
